<template>
  <div>
    <BillingForm />
  </div>
</template>
<script>
import BillingForm from "../pages/Billing/BillingForm.vue";
export default {
  components: {
    BillingForm,
  },
};
</script>
